import db from '@/common/localstorage'
import Cookies from 'js-cookie'
export default {
  namespaced: true,
  state: {
    token: Cookies.get('token'),
    expireTime: db.get('EXPIRE_TIME'),
    user: db.get('userInfo'),
    permissions: db.get('PERMISSIONS'),
    roles: db.get('ROLES'),
    uploadFile: db.get('uploadFile'),
    isActive:false,
  },
  mutations: {
    setToken(state, val) {
      db.save('token', val)
      state.token = val
    },
    setUploadFile(state, val) {
      db.saveLoaclStorage('uploadFile', val);
      state.uploadFile = val;
    },
    setExpireTime(state, val) {
      db.save('EXPIRE_TIME', val)
      state.expireTime = val
    },
    setUser(state, val) {
      db.saveLoaclStorage('userInfo', val);
      state.user = val
    },
    setPermissions(state, val) {
      db.saveLoaclStorage('PERMISSIONS', val)
      state.permissions = val
    },
    setRoles(state, val) {
      // db.save('ROLES', val)
      db.saveLoaclStorage('ROLES', val);
      state.roles = val
    }
  }
}
